module.exports = __webpack_public_path__ + "media/images/icon/user-3548f67548ed9502d24acc4adf62577c.svg";